<div *ngIf="opportunity$ | async as opportunity">
  <sales-ui-type-selector
    [defaultType]="initialType$ | async"
    (typeChanged)="handleTypeChange(opportunity, $event)"
  ></sales-ui-type-selector>
</div>
